import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Col, Flex, Form, Input, Row, Popconfirm } from "antd";
import { DeleteFilled, ExceptionOutlined } from "@ant-design/icons";
import { SectionHeader } from "../../components/SectionHeader/SectionHeader";
import { getLogEntries, deleteReport, clearData } from "./reportSlice";
import { HeaderCell } from "../Dashboard/HeaderCell";
import { dateCell } from "../../components/DateCell/DateCell";
import { Notification } from "../../components/Notification/Notification";
import { PageHeader } from "../../components/PageHeader/PageHeader";
import Table from "../../components/SortableTable/SortableTable";
import css from "./Report.module.css";


export const Logs = ({upc}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [sortDirection, setSortDirection] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationError, setNotificationError] = useState(false);
  
  const [type, setType] = useState("type");
  const page = new URLSearchParams(location.search).get("page") || 1;
  const search = new URLSearchParams(location.search).get("search");
  const sort = new URLSearchParams(location.search).get("sort");

  const { logEntries, getLogEntriesInProgress } =
	useSelector((state) => state?.report) || {};

  useEffect(() => {
	dispatch(
	  getLogEntries({
		type,  
		page,
		search,
		sort: sortDirection,
	  }),
	);
  }, [type, page, search, sortDirection]);
  
  useEffect(() => {
	  if (
		location.state &&
		["/uploaded", "/upload-error"].includes(location.state.from)
	  ) {
		setShowNotification(true);
		setNotificationError(location.state.from !== '/uploaded');
		navigate("/report/logs", { state: null });
	  } else {
		setShowNotification(false);
	  }
  }, [location?.state]);
  
  const deleteReportCall = async (id) => {
	  await dispatch(deleteReport(id));
	  await dispatch(getLogEntries());
  }
  
  const columns = [
	{
	  title: "Report Date",
	  editable: true,
	  dataIndex: "reportDate",
	  sorter: true,
	  align: "left",
	  render: (record) => dateCell(record)
	},
	{
	  title: "Import Date",
	  editable: true,
	  dataIndex: "importedAt",
	  sorter: true,
	  align: "left",
	  render: (record) => dateCell(record),
	  defaultSortOrder: 'descend'
	},
	{
	  title: "User",
	  editable: true,
	  dataIndex: "user",
	  sorter: true,
	  align: "left"
	},

	{
	  title: "Partner",
	  editable: true,
	  dataIndex: "partner",
	  sorter: true,
	  align: "left",
	},
	{
	  title: "Target",
	  editable: true,
	  dataIndex: "target",
	  sorter: true,
	  align: "left",
	  render: (record) => record || 'N/A'
	},

	{
	  title: "# Lines Ingested",
	  editable: true,
	  dataIndex: "uploadCount",
	  // width: 200,
	  sorter: true,
	  align: "left",
	},
	{
	  title: "# Valid Rows",
	  editable: true,
	  dataIndex: "validCount",
	  // width: 200,
	  sorter: true,
	  align: "left",
	},

	{
	  title: "# Exceptions",
	  editable: true,
	  dataIndex: "exceptionsCount",
	  // width: 200,
	  sorter: true,
	  align: "left",
	},

	{
	  title: "Actions",
	  dataIndex: "",
	  fixed: "right",
	  key: "x",
	  width: 100,
	  align: "left",
	  className: 'action',
	  render: (record) => {
		return (
		  <Flex gap={16} align={"center"}>
			<div className={css.actionContainer}>
				{record.exceptionsCount > 0 && <Link to={`/report/exceptions/${record.rowKey.id}`}>
					<ExceptionOutlined />
				</Link>}
				<Popconfirm
				title="Are you sure you want to delete this report?"
				onConfirm={() => {
					deleteReportCall(record.rowKey.id);
				}}
				okText="Yes"
				cancelText="No"
				>
	
					<span className={css.actionIcon}>
					<DeleteFilled />
					</span>
				</Popconfirm>
			</div>
		  </Flex>
		);
	  },
	},

	
  ];

  return (
	  <>
	  <PageHeader title="Import Logs" extraClass={css.reportTitle} />
		<Flex className={css.root} vertical>
		<div className={"ibox-holder"}>

			<Notification
				mode={`${notificationError?'error':'success'}`}
				message={`${notificationError?'Error':'Success'}`}
				description={`${notificationError?'Error uploading file':'File was uploaded successfully'}`} 
				showNotification={showNotification}
				cancel={() => setShowNotification(false)}
			/>

			<Table
				components={{
					header: {
						row: HeaderCell,
					},
				}}
				columns={columns}
				rowKey={(record) => record.id}
				dataSource={logEntries}
				pagination={{
					position: ["bottomRight"],
					responsive: true,
					// onChange: (page) => onQueryParamsChange({ page }),
					// current: page,
					total: logEntries.length,
					pageSize: 10,
					hideOnSinglePage: true,
					showSizeChanger: false,
				}}
				loading={getLogEntriesInProgress}
				style={{ marginTop: 10 }}
				scroll={{ x: 'max-content' }}
				className={css.importTable}
			/>
			</div>
		</Flex>
		
		</>
  );
};
